import styled from '@emotion/styled'
import { ReactNode, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Breakpoint from '../../../Breakpoint'
import { useMenu } from '../../../context/MenuContext'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import AdminSideBar from './AdminSideBar'
import CoachSideBar from './CoachSideBar'
import MemberSideBar from './MemberSideBar'

export const Main = ({ children }: { children: ReactNode }) => {
    const location = useLocation()
    const { isMenuOpen, closeMenu } = useMenu()
    let lng = useLangSelected()

    const user = useContext(UserContext)

    const isAdmin = location.pathname.includes('bva-admin') && location.pathname !== `/${lng}/login`
    const isMember = location.pathname.includes('bva-membre') && location.pathname !== `/${lng}/login`
    const isCoach = location.pathname.includes('bva-coach') && location.pathname !== `/${lng}/login`
    const isConnected = isAdmin || isMember || isCoach

    // Close menu when location changes
    useEffect(() => {
        closeMenu()
    }, [location.pathname, closeMenu])

    const chooseSideBar = (children: ReactNode) => {
        if (isAdmin && user.adminData && !location.pathname.includes('login'))
            return <AdminSideBar isOpen={isMenuOpen}>{children}</AdminSideBar>
        else if (isMember && user.memberData && !location.pathname.includes('login'))
            return <MemberSideBar isOpen={isMenuOpen}>{children}</MemberSideBar>
        else if (isCoach && user.coachData && !location.pathname.includes('login'))
            return <CoachSideBar isOpen={isMenuOpen}>{children}</CoachSideBar>
        return children
    }

    return (
        <MainStyled
            isConnected={isConnected}
            isMenuOpen={isMenuOpen}
            isPlanningPage={location.pathname.includes('horaires-et-tarifs')}
        >
            {chooseSideBar(children)}
        </MainStyled>
    )
}

const MainStyled = styled.main<{ isConnected: boolean; isMenuOpen?: boolean; isPlanningPage?: boolean }>`
    ${({ isConnected }) => isConnected && 'display: flex;'}
    min-height: ${({ isConnected }) => (isConnected ? 'calc(100vh - 158px)' : 'calc(100vh - 58px)')};
    padding: ${({ isPlanningPage }) => (isPlanningPage ? '180px' : '130px')} 0 0 0;
    z-index: 1;
    transition: margin-left 0.3s ease-in-out;
    margin-left: ${({ isMenuOpen }) => (isMenuOpen ? '250px' : '0')};
    width: 100%;
    overflow: hidden;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        margin-left: 0;
        padding-top: 100px;
        padding-bottom: 32px;
    }
`

export default Main
